import styled from 'styled-components'

export const FormWrapper = styled.div`
  width: 600px;
  max-width: 100%;
  padding: 1rem;
  margin: 0 auto;
`

export const SliderContainer = styled.div`
  width: 600px;
  max-width: 100%;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  height: 100%;
  max-height: 100%;
`

export const SliderWrapper = styled.div<{ $translate: string }>`
  display: flex;
  width: 200%;
  height: 100%;
  transform: translateX(${({ $translate }) => $translate});
  transition: transform 0.4s ease-in-out;
`

export const Slide = styled.div`
  width: 50%;
  flex-shrink: 0;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  form {
    overflow: auto;
    flex: 1;
  }
`
